export function extractPercentageStrings(input) {
    let regex = /\d[.,\d ]*%/g;
    let matches = input.match(regex) || [];
    if (matches.length > 0) {
        return matches;
    }
    
    regex = /(\$|£|€|EUROS|EURO|EUR|ARS|CLP|PEN|COP|MXN|USD|CAD|CHF|SFR|AUD|NZD|GBP|R\$|BRL)\s*[\d]+[.,\-\d+]*[\-\d]|[\d]+[.,\-\s\d]*[\-\d\s](\$|£|€|EUROS|EURO|EUR|ARS|CLP|PEN|COP|MXN|USD|CAD|CHF|SFR|AUD|NZD|GBP|R\$|BRL)/i;
    matches = input.match(regex);
    if (matches && matches.length > 0) {
        return matches;
    }
    
    return ['%'];
    
}
